import { FC, useEffect, useReducer } from 'react';
import {
  RetryModalActionType,
  retryModalReducer,
} from 'src/pages/VerificationPage/reducers/retryModalReducer';
import { RetryModal } from 'src/pages/VerificationPage/components/RetryModal';
import { useProcessRetryMessage } from 'src/pages/VerificationPage/verificationQueries';
import { VerificationStatus } from 'src/common/models/verificationModels';
import { useVerificationId } from 'src/common/hooks/useVerificationId';

export type RetryVerificationProcessModalProps = {
  verificationStatus?: VerificationStatus;
  onClose?: () => void;
  openDelayMs?: number;
};

export const RetryVerificationProcessModal: FC<
  RetryVerificationProcessModalProps
> = ({ verificationStatus, onClose, openDelayMs = 0 }) => {
  const verificationId = useVerificationId();
  const isEnabled = VerificationStatus.InsufficientData === verificationStatus;

  const [retryModalState, dispatchRetryModal] = useReducer(retryModalReducer, {
    isVisible: false,
  });

  const retryMessage = useProcessRetryMessage({
    id: verificationId,
    enabled: isEnabled,
  });

  useEffect(() => {
    if (!retryMessage.data) {
      return;
    }

    const openModal = () => {
      dispatchRetryModal({
        type: RetryModalActionType.Open,
        payload: retryMessage.data,
      });
    };

    if (openDelayMs > 0) {
      const timeoutId = setTimeout(openModal, openDelayMs);
      return () => clearTimeout(timeoutId);
    }

    openModal();
  }, [retryMessage.data, openDelayMs]);

  return retryModalState.retryMessage && verificationId ? (
    <RetryModal
      open={retryModalState.isVisible}
      onClose={() => {
        dispatchRetryModal({ type: RetryModalActionType.Close });
        onClose?.();
      }}
      verificationId={verificationId}
      message={retryModalState.retryMessage}
    />
  ) : null;
};
